import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {

lottieOptions: AnimationOptions = {
  path: './assets/animations/onboarding-loader.json', // your lottie file path
  renderer: 'svg',
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice' // or "none", "meet", "xMidYMid"
  }
};

  constructor() { }

  ngOnInit(): void {
  }

}
